import { useEffect, useState } from "react";

export const useDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const isSmallScreen = windowDimensions.width < 768;
  const isMediumScreen = windowDimensions.width >= 768 && windowDimensions.width < 1102;
  const isLargeScreen = windowDimensions.width >= 1102;
  const isMobile = isSmallScreen; // Used by the sidebar

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { windowDimensions, isSmallScreen, isMediumScreen, isLargeScreen, isMobile };
};
